// Simplified-Chinese strings for the auth area. Keys are the exact English source strings.
export const auth: Record<string, string> = {
  // Sign in
  'Sign in': '登录',
  'Welcome back to your video learning.': '欢迎回到你的视频学习。',
  'Remember me': '记住我',
  'Forgot password?': '忘记密码？',
  'Create account': '创建账户',
  // Sign up
  'Create your account': '创建你的账户',
  'Start pinning what you learn.': '开始标记你所学到的内容。',
  'Confirm password': '确认密码',
  'Already have an account?': '已经有账户了？',
  // Forgot password
  'Reset password': '重置密码',
  "We'll email you a reset link.": '我们会向你发送一封重置链接邮件。',
  'Send reset link': '发送重置链接',
  'Back to sign in': '返回登录',
  // Reset password
  'Choose a new password': '设置新密码',
  'New password': '新密码',
  'Confirm new password': '确认新密码',
  'Update password': '更新密码',
  // Shared fields
  'Email': '邮箱',
  'Password': '密码',
}
